import React, { useEffect } from 'react'
import "../assets/pages-css/home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Welcomes from '../components/globals/home/welcomes';
import Embrace from '../components/globals/home/embrace';
import Getstartedtoday from '../components/globals/home/getstartedtoday';
import Explore from '../components/globals/home/explore';
import Userlove from '../components/globals/home/userlove';
import Joindual from '../components/globals/home/joindual';
import Contactus from '../components/globals/home/contactus';
import Footer from '../components/globals/home/footer';
import Copyright from '../components/globals/home/copyright';


const Home = () => {

  return (
    <div >
      <Welcomes />
      <Embrace />
      <Getstartedtoday />
      <Explore />
      {/* <Userlove /> */}
      {/* <Joindual /> */}
      <Contactus />
      <Footer />
      <Copyright />
    </div>
  )
}

export default Home
